import { RouterProvider } from '@tanstack/react-router';
import { router } from './providers/router';
import 'ui_2/src/index.css';

function App() {
  return (
    <div className='fixed h-[100dvh] w-full bg-gray-900'>
      <div className='mx-auto h-full max-w-[478px] bg-squashBg'>
        <RouterProvider router={router} />
      </div>
    </div>
  );
}

export default App;
